import { Injectable } from '@angular/core';

import { map, catchError } from 'rxjs/operators';
import { APIBaseService } from './api_base.service';
import { domain, domainRaw } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationServiceApi extends APIBaseService {
  namespace = 'notification';

  pull() {
    if (!this.g.jws) return;

    const params = {};
    const options = { ...this.getHeader(), params };
    const url = `${domainRaw}/general/access/${this.namespace}`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async reads(json) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/reads`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async list(json) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/list`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async read(data) {
    const url = `${domain}/${this.namespace}/read`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async add(data) {
    const url = `${domain}/${this.namespace}/add`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async get(id) {
    const url = `${domain}/${this.namespace}/${id}/get`;
    return this.http.get(url, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async update(id, model) {
    const url = `${domain}/${this.namespace}/${id}/update`;
    return this.http.post(url, model, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async locationNotification(data) {
    const url = `${domain}/${this.namespace}/locationNotification`;
    return this.http.post(url,{data}, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
}
